import moment from "moment";
import fingerprintJS from "@fingerprintjs/fingerprintjs";
import { saveAs } from 'file-saver';

/**
 * 存储localStorage
 */
export const setStore = (name, content) => {
  if (!name) return;
  if (typeof content !== 'string') {
    content = JSON.stringify(content);
  }
  window.localStorage.setItem(name, content);
}

/**
 * 获取localStorage
 */
export const getStore = name => {
  if (!name) return;
  return window.localStorage.getItem(name);
}

export const saveUserInStore = (data) => {
  setStore("auth_token", data.Token);
  setStore("user_role", data.Role);
  setStore("user_id", data.Id);
  setStore("user_name", data.Name);
  setStore("user_student_id", data.StudentId);
  setStore("user_student_phone", data.StudentPhone);
  setStore("user_student_email", data.StudentEmail);
  setStore("user_student_isEmailValidated", data.StudentIsEmailValidated ? 1 : 0);
  setStore("user_student_universityName", data.UniversityName);
  setStore("user_student_universityAbbreviation", data.UniversityAbbreviation);
  setStore("user_student_studentInProgressWorkflowCount", data.StudentInProgressWorkflowCount);
  setStore("user_student_universityEmailAccount", data.UniversityEmailAccount);
  setStore("user_teacher_id", data.TeacherId);
  setStore("user_isAssistantTeacher", data.IsAssistantTeacher ? "1" : "0");

  let hasStudentCourseNumber = 0;
  if (data.HasStudentCourseNumber) {
    hasStudentCourseNumber = 1;
  }
  setStore("user_student_hasStudentCourseNumber", hasStudentCourseNumber);

  let studentEnable = 0;
  if (data.StudentEnable) {
    studentEnable = 1;
  }
  setStore("user_student_enable", studentEnable);

  let hasSaturdayCourse = 0;
  if (data.HasSaturdayCourse) {
    hasSaturdayCourse = 1;
  }
  setStore("user_student_hasSaturdayCourse", hasSaturdayCourse);

  let hasSundayCourse = 0;
  if (data.HasSundayCourse) {
    hasSundayCourse = 1;
  }
  setStore("user_student_hasSundayCourse", hasSundayCourse);

  let hasUninputedInfo = 0;
  if (!data.StudentFirstName || !data.StudentLastName || !data.StudentEmail) {
    hasUninputedInfo = 1;
  }
  setStore("user_student_hasUninputedInfo", hasUninputedInfo);

  let hasWechat = 0;
  if (data.HasWechat) {
    hasWechat = 1;
  }
  setStore("user_student_hasWechat", hasWechat);

  let enableAutonomousEnrolment = 0;
  if (data.EnableAutonomousEnrolment) {
    enableAutonomousEnrolment = 1;
  }
  setStore("user_student_enableAutonomousEnrolment", enableAutonomousEnrolment);

  let isSAStudent = data.IsSAStudent ? 1 : 0;
  setStore("user_student_isSAStudent", isSAStudent);

  let hasUnsignedContracts = 0;
  if (data.HasUnsignedContracts) {
    hasUnsignedContracts = 1;
  }
  setStore("user_student_hasUnsignedContracts", hasUnsignedContracts);
}

export const saveUserWechatPassInStore = () => {
  let str = "pass";
  let code = compileStr(str);
  setStore("user_student_wechatPass", code);
}

export const getUserWechatPassInStore = () => {
  let code = getStore("user_student_wechatPass");
  if (code){
    return uncompileStr(code);
  }
  return "";
}

export const checkUserWechatPass = () => {
  let configStr = getStore("weChatConfig");
  let configObj = JSON.parse(uncompileStr(configStr));
  if (!configObj.Enable){
    return true;
  }
  let user_student_hasWechat = getStore("user_student_hasWechat");
  if (user_student_hasWechat == "1"){
    let value = getUserWechatPassInStore();
    if (value == "pass"){
      return true;
    }
  }
  return false;
}

export const clearUserInStore = () => {
  removeStore("auth_token");
  removeStore("user_role");
  removeStore("user_id");
  removeStore("user_name");
  removeStore("user_student_id");
  removeStore("user_student_universityName")
  removeStore("user_student_hasStudentCourseNumber");
  removeStore("user_student_enable");
  removeStore("user_student_hasSaturdayCourse");
  removeStore("user_student_hasSundayCourse");
  removeStore("user_student_universityAbbreviation");
  removeStore("user_student_enableAutonomousEnrolment");
  removeStore("user_student_hasWechat");
  removeStore("user_student_wechatPass");
  removeStore("user_student_studentInProgressWorkflowCount");
  removeStore("user_student_universityEmailAccount");
  removeStore("user_student_hasUnsignedContracts");
  removeStore("user_isAssistantTeacher");
  removeStore("user_student_isSAStudent");
}

export const getSproutVideoUploadTokenInStore = () => {
  let token = getStore("sproutVideo_token");
  if (!!token){
    token = atob(token);
  }

  let data = {
    token: token,
    createTime: getStore("sproutVideo_token_createTime"),
  }
  return data;
}

export const saveSproutVideoUploadTokenInStore = (token,createTime) => {
  if (!!token){
    let tokenEncode = btoa(token);
    setStore("sproutVideo_token", tokenEncode);
    setStore("sproutVideo_token_createTime", createTime);
  }
}

export const clearSproutVideoUploadTokenInStore = () => {
  removeStore("sproutVideo_token");
  removeStore("sproutVideo_token_createTime");
}

/**
 * 删除localStorage
 */
export const removeStore = name => {
  if (!name) return;
  window.localStorage.removeItem(name);
}

export const getUrlRelativePath = () => {
  var url = window.location.toString();
  var arrUrl = url.split("//");


  var start = arrUrl[1].indexOf("/");
  var relUrl = arrUrl[1].substring(start); //stop省略，截取从start开始到结尾的所有字符


  if (relUrl.indexOf("?") != -1) {
    relUrl = relUrl.split("?")[0];
  }
  return relUrl;
}

// export const getTermCourseListCache = (termId)=>{
//   let jsonCourseList = window.localStorage.getItem("course_list");
//   let courseList = JSON.parse(jsonCourseList);
//   if(courseList && courseList.TermId == termId){
//     return courseList.List;
//   }
//   return null;
// }

// export const setTermCourseListCache = (courseList)=>{
//   let jsonCourseList = JSON.stringify(courseList);
//   setStore("course_list", jsonCourseList);
// }

// export const getContractListCache = ()=>{
//   let jsonContractList = window.localStorage.getItem("contract_list");
//   let list = JSON.parse(jsonContractList);
//   return list;
// }

// export const getContractViewModelListCache = ()=>{
//   let jsonContractList = window.localStorage.getItem("contract_viewmodel_list");
//   let list = JSON.parse(jsonContractList);
//   return list;
// }

// export const setContractViewModelListCache = (contractList)=>{
//   let jsonContractList = JSON.stringify(contractList);
//   setStore("contract_viewmodel_list", jsonContractList);
// }

// export const setContractListCache = (contractList)=>{
//   let jsonContractList = JSON.stringify(contractList);
//   setStore("contract_list", jsonContractList);
// }

export const getObjectInCache = (name) => {
  let strJson = window.localStorage.getItem(name);
  if (!strJson) {
    return false;
  }
  let obj = JSON.parse(strJson);
  return obj;
}

export const getDatePart = (date, partName) => {
  let mDate = moment(date);
  if (!mDate.isValid() || !partName)
    return null;
  
  let lowerPartName = partName.toLowerCase();
  if (!mDate[lowerPartName])
    return null;

  switch (lowerPartName) {
    case "month":
      return mDate[lowerPartName]() + 1;
    default:
      return mDate[lowerPartName]();
  }
}

export const formatMinutes = (value, isAbbreviation) => {
  let n = 0;
  if (!!value) {
    n = parseInt(value);
  }
  let hour = Math.floor(n / 60);
  let minute = Math.floor(n % 60);

  let hour_str = hour.toString();
  let minute_str = minute.toString();

  if (minute_str.length == 1) {
    minute_str = '0' + minute_str;
  }

  if (isAbbreviation){
    return hour_str + 'h' + minute_str + 'm';
  }else{
    return hour_str + ':' + minute_str;
  }
}

export const formatTime = (hour, minute) => {
  if (hour == null || minute == null) {
    return '';
  }
  if (typeof hour == 'string') {
    hour = parseInt(hour);
  }
  if (typeof minute == 'string') {
    minute = parseInt(minute);
  }

  if (hour > 24){
    hour -= 24;
  }

  let ext = '';
  let hour_str = '';
  let minute_str = minute.toString();
  if (hour <= 12) {
    //if(hour == 12 && minute == 30){
    if (hour == 12) {
      ext = 'PM';
    } else {
      ext = 'AM';
    }

    hour_str = hour.toString();
  } else {
    hour_str = (hour - 12).toString();
    ext = 'PM';
    if (hour == 24) {
      ext = 'AM';
    }
  }
  if (minute_str.length == 1) {
    minute_str = '0' + minute_str;
  }

  return hour_str + ':' + minute_str + ' ' + ext;
}

export const formatTimeFromInt60 = (value) => {
  let n = 0;
  if (!!value) {
    n = parseInt(value);
  }
  let hour = Math.floor(n / 60);
  let minute = Math.floor(n % 60);
  return formatTime(hour, minute);
}

export const formatTimeToInt60 = (time, isEndTime) => {
  if (!time) {
    return 0;
  }
  let strHour = "";
  let strMinue = "";
  time = time.toLowerCase();

  if (time.indexOf(":") > 0) {
    let list = time.split(":");
    if (list.length > 1) {
      strHour = list[0];
      strMinue = list[1];
    }
  } else {
    strHour = time;
  }

  if (time.indexOf('am') > 0) {
    strMinue = strMinue.replace('am', '');
  } else if (time.indexOf('pm') > 0) {
    strMinue = strMinue.replace('pm', '');
  }
  if (isEndTime && time == "12:00 am"){
    strHour = "24";
    strMinue = "0";
  }

  let hour = parseInt(strHour);
  let minute = parseInt(strMinue);

  if (time.indexOf('pm') > 0 && hour < 12) {
    hour += 12;
  }

  let result = hour * 60 + minute;
  return result;
}

export const formatTimeFromInt = (value) => {
  let n = 0;
  if (!!value) {
    n = parseInt(value);
  }
  let hour = Math.floor(n / 100);
  let minute = Math.floor(n % 100);

  return formatTime(hour, minute);
}

export const formatTimeToInt = (time) => {
  let strHour = "";
  let strMinue = "";
  time = time.toLowerCase();

  if (time.indexOf(":") > 0) {
    let list = time.split(":");
    if (list.length > 1) {
      strHour = list[0];
      strMinue = list[1];
    }
  } else {
    strHour = time;
  }

  if (time.indexOf('am') > 0) {
    strMinue = strMinue.replace('am', '');
  } else if (time.indexOf('pm') > 0) {
    strMinue = strMinue.replace('pm', '');
  }

  let hour = parseInt(strHour);
  let minute = parseInt(strMinue);

  if (time.indexOf('pm') > 0 && hour < 12) {
    hour += 12;
  }

  let result = hour * 100 + minute;
  return result;
}

export const guid = () => {
  function S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  }
  return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
}

export const getColorList = () => {
  let colorList = [
    '#357EC7',
    '#41A317',
    '#FBB117',
    '#E2A76F',
    '#CD7F32',
    '#C36241',
    '#810541',
    '#E45E9D',
    '#8467D7',
    '#6698FF',
    '#0c7b7b',
    '#1e4a4a',
    '#3B9C9C',
    '#728C00',
    '#52D017',
    '#545428',
    '#FFA62F',
    '#966F33',
    '#E66C2C',
    '#C11B17',
    '#F52887',
  ];

  return colorList;
}

export const getTermYearList = () => {
  let list = [{
    Value: 2017,
    Text: "2017"
  },
  {
    Value: 2018,
    Text: "2018"
  },
  {
    Value: 2019,
    Text: "2019"
  },
  {
    Value: 2020,
    Text: "2020"
  },
  {
    Value: 2021,
    Text: "2021"
  },
  {
    Value: 2022,
    Text: "2022"
  },
  {
    Value: 2023,
    Text: "2023"
  },
  {
    Value: 2024,
    Text: "2024"
  },
  {
    Value: 2025,
    Text: "2025"
  },
  {
    Value: 2026,
    Text: "2026"
  },
  {
    Value: 2027,
    Text: "2027"
  },
  {
    Value: 2028,
    Text: "2028"
  },
  {
    Value: 2029,
    Text: "2029"
  },
  {
    Value: 2030,
    Text: "2030"
  },
  {
    Value: 2031,
    Text: "2031"
  },
  {
    Value: 2032,
    Text: "2032"
  },
  {
    Value: 2033,
    Text: "2033"
  },
  {
    Value: 2034,
    Text: "2034"
  },
  {
    Value: 2035,
    Text: "2035"
  },
  {
    Value: 2036,
    Text: "2036"
  },
  {
    Value: 2037,
    Text: "2037"
  },
  {
    Value: 2038,
    Text: "2038"
  },
  {
    Value: 2039,
    Text: "2039"
  },
  {
    Value: 2040,
    Text: "2040"
  }
  ];
  return list;
}

export const getTermSeasonList = () => {
  let list = [{
    Value: 1,
    Text: "Spring"
  },
  {
    Value: 2,
    Text: "Summner"
  },
  {
    Value: 3,
    Text: "Fall"
  },
  ];
  return list;
}

export const getScoreList = () => {
  let list = [{
    Value: "A+",
    Text: "A+"
  },
  {
    Value: "A",
    Text: "A"
  },
  {
    Value: "A-",
    Text: "A-"
  },
  {
    Value: "B+",
    Text: "B+"
  },
  {
    Value: "B",
    Text: "B"
  },
  {
    Value: "B-",
    Text: "B-"
  },
  {
    Value: "C+",
    Text: "C+"
  },
  {
    Value: "C",
    Text: "C"
  },
  {
    Value: "C-",
    Text: "C-"
  }
  ]
  return list;
}

export const getEnglishScoreList = () => {
  let list = [];
  for (let i = 18; i >= 2; i--) {
    let value = i / 2;
    let str = "";
    if (i % 2 == 0) {
      str = value.toFixed("0");
    } else {
      str = value.toFixed("1");
    }
    list.push({
      Value: str,
      Text: str
    });
  }

  return list;
}

export const getNewStudentGuideScoreList = () => {
  let list = [];
  for (let i = 18; i >= 2; i--) {
    let value = i / 2;
    let str = "";
    if (i % 2 == 0) {
      str = value.toFixed("0");
    } else {
      str = value.toFixed("1");
    }
    list.push({
      Value: str,
      Text: str
    });
  }

  return list;
}

export const getPaymentImgList = () => {
  let list = {
    wechat: require("../assets/payment-wechat.png"),
    alipay: require("../assets/payment-alipay.png"),
    cash: require("../assets/payment-cash.png"),
    debit: require("../assets/payment-debit.png"),
    emt: require("../assets/payment-emt.png"),
    master: require("../assets/payment-master.png"),
    paypal: require("../assets/payment-paypal.png"),
    union: require("../assets/payment-union.png"),
    visa: require("../assets/payment-visa.png"),
    cheque: require("../assets/payment-cheque.png"),
    creditCard: require("../assets/payment-creditCard.png")
  };
  return list;
}

export const getEMTExampleImgList = () => {
  let list = {
    payment2: require("../assets/emt_example_payment2.jpg"),
    payment3: require("../assets/emt_example_payment3.jpg"),
    payment4: require("../assets/emt_example_payment4.jpg"),
    payment6: require("../assets/emt_example_payment6.jpg"),
    payment7: require("../assets/emt_example_payment7.jpg"),
    payment8: require("../assets/emt_example_payment8.jpg"),
    payment9: require("../assets/emt_example_payment9.jpg"),
    payment10: require("../assets/emt_example_payment10.jpg")
  };
  return list;
}

export const getCourseType = (removeEnglish, isTraining) => {
  let list = [
    {
      Text: "大学补习",
      NameValue: "1",
      Value: 1
    },
    {
      Text: "应试英语",
      NameValue: "2",
      Value: 2
    }, {
      Text: "职业培训",
      NameValue: "3",
      Value: 3
    }
  ]
  if (isTraining){
    list = list.filter(i => i.Value === 3);
  }else if(removeEnglish){
    list = list.filter(i => i.Value !== 2);
  }
  return list;
}

export const dayOfWeekToString = (dayOfWeek) => {
  switch (dayOfWeek) {
    case 0:
      return "周日";
    case 1:
      return "周一";
    case 2:
      return "周二";
    case 3:
      return "周三";
    case 4:
      return "周四";
    case 5:
      return "周五";
    case 6:
      return "周六";
    default:
      return "";
  }
}

export const addMonth = (date, num) => {
  num = parseInt(num);
  var sDate = dateToDate(date);

  var sYear = sDate.getFullYear();
  var sMonth = sDate.getMonth() + 1;
  var sDay = sDate.getDate();

  var eYear = sYear;
  var eMonth = sMonth + num;
  var eDay = sDay;
  while (eMonth > 12) {
    eYear++;
    eMonth -= 12;
  }
  let m = eMonth - 1;
  if (m < 0) {
    eYear = eYear - 1;
    m = 12 + m;
  }
  var eDate = new Date(eYear, m, eDay);

  let count = 0;
  while (eDate.getMonth() != m) {
    eDay--;
    eDate = new Date(eYear, m, eDay);
    count++;
    if (count >= 1000) {
      break;
    }
  }
  // var eDate = new Date(eYear, eMonth - 1, eDay);

  // while (eDate.getMonth() != eMonth - 1) {
  //   eDay--;
  //   eDate = new Date(eYear, eMonth - 1, eDay);
  // }

  return eDate;
}

export const formatDate = (date) => {
  var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;

  return [year, month, day].join('-');
}

export const dateToDate = (date) => {
  var sDate = new Date();
  if (typeof date == 'object' &&
    typeof new Date().getMonth == "function"
  ) {
    sDate = date;
  } else if (typeof date == "string") {
    var arr = date.split('-')
    if (arr.length == 3) {
      sDate = new Date(arr[0] + '-' + arr[1] + '-' + arr[2]);
    }
  }

  return sDate;
}

/**
 * 获取style样式
 */
export const getStyle = (element, attr, NumberMode = 'int') => {
  let target;
  // scrollTop 获取方式不同，没有它不属于style，而且只有document.body才能用
  if (attr === 'scrollTop') {
    target = element.scrollTop;
  } else if (element.currentStyle) {
    target = element.currentStyle[attr];
  } else {
    target = document.defaultView.getComputedStyle(element, null)[attr];
  }
  //在获取 opactiy 时需要获取小数 parseFloat
  return NumberMode == 'float' ? parseFloat(target) : parseInt(target);
}

/**
 * 页面到达底部，加载更多
 */
export const loadMore = (element, callback) => {
  let windowHeight = window.screen.height;
  let height;
  let setTop;
  let paddingBottom;
  let marginBottom;
  let requestFram;
  let oldScrollTop;

  document.body.addEventListener('scroll', () => {
    loadMore();
  }, false)
  //运动开始时获取元素 高度 和 offseTop, pading, margin
  element.addEventListener('touchstart', () => {
    height = element.offsetHeight;
    setTop = element.offsetTop;
    paddingBottom = getStyle(element, 'paddingBottom');
    marginBottom = getStyle(element, 'marginBottom');
  }, {
    passive: true
  })

  //运动过程中保持监听 scrollTop 的值判断是否到达底部
  element.addEventListener('touchmove', () => {
    loadMore();
  }, {
    passive: true
  })

  //运动结束时判断是否有惯性运动，惯性运动结束判断是非到达底部
  element.addEventListener('touchend', () => {
    oldScrollTop = document.body.scrollTop;
    moveEnd();
  }, {
    passive: true
  })

  const moveEnd = () => {
    requestFram = requestAnimationFrame(() => {
      if (document.body.scrollTop != oldScrollTop) {
        oldScrollTop = document.body.scrollTop;
        loadMore();
        moveEnd();
      } else {
        cancelAnimationFrame(requestFram);
        //为了防止鼠标抬起时已经渲染好数据从而导致重获取数据，应该重新获取dom高度
        height = element.offsetHeight;
        loadMore();
      }
    })
  }

  const loadMore = () => {
    if (document.body.scrollTop + windowHeight >= height + setTop + paddingBottom + marginBottom) {
      callback();
    }
  }
}

/**
 * 显示返回顶部按钮，开始、结束、运动 三个过程中调用函数判断是否达到目标点
 */
export const showBack = callback => {
  let requestFram;
  let oldScrollTop;

  document.addEventListener('scroll', () => {
    showBackFun();
  }, false)
  document.addEventListener('touchstart', () => {
    showBackFun();
  }, {
    passive: true
  })

  document.addEventListener('touchmove', () => {
    showBackFun();
  }, {
    passive: true
  })

  document.addEventListener('touchend', () => {
    oldScrollTop = document.body.scrollTop;
    moveEnd();
  }, {
    passive: true
  })

  const moveEnd = () => {
    requestFram = requestAnimationFrame(() => {
      if (document.body.scrollTop != oldScrollTop) {
        oldScrollTop = document.body.scrollTop;
        moveEnd();
      } else {
        cancelAnimationFrame(requestFram);
      }
      showBackFun();
    })
  }

  //判断是否达到目标点
  const showBackFun = () => {
    if (document.body.scrollTop > 500) {
      callback(true);
    } else {
      callback(false);
    }
  }
}


/**
 * 运动效果
 * @param {HTMLElement} element   运动对象，必选
 * @param {JSON}        target    属性：目标值，必选
 * @param {number}      duration  运动时间，可选
 * @param {string}      mode      运动模式，可选
 * @param {function}    callback  可选，回调函数，链式动画
 */
export const animate = (element, target, duration = 400, mode = 'ease-out', callback) => {
  clearInterval(element.timer);

  //判断不同参数的情况
  if (duration instanceof Function) {
    callback = duration;
    duration = 400;
  } else if (duration instanceof String) {
    mode = duration;
    duration = 400;
  }

  //判断不同参数的情况
  if (mode instanceof Function) {
    callback = mode;
    mode = 'ease-out';
  }

  //获取dom样式
  const attrStyle = attr => {
    if (attr === "opacity") {
      return Math.round(getStyle(element, attr, 'float') * 100);
    } else {
      return getStyle(element, attr);
    }
  }
  //根字体大小，需要从此将 rem 改成 px 进行运算
  const rootSize = parseFloat(document.documentElement.style.fontSize);

  const unit = {};
  const initState = {};

  //获取目标属性单位和初始样式值
  Object.keys(target).forEach(attr => {
    if (/[^\d^\.]+/gi.test(target[attr])) {
      unit[attr] = target[attr].match(/[^\d^\.]+/gi)[0] || 'px';
    } else {
      unit[attr] = 'px';
    }
    initState[attr] = attrStyle(attr);
  });

  //去掉传入的后缀单位
  Object.keys(target).forEach(attr => {
    if (unit[attr] == 'rem') {
      target[attr] = Math.ceil(parseInt(target[attr]) * rootSize);
    } else {
      target[attr] = parseInt(target[attr]);
    }
  });


  let flag = true; //假设所有运动到达终点
  const remberSpeed = {}; //记录上一个速度值,在ease-in模式下需要用到
  element.timer = setInterval(() => {
    Object.keys(target).forEach(attr => {
      let iSpeed = 0; //步长
      let status = false; //是否仍需运动
      let iCurrent = attrStyle(attr) || 0; //当前元素属性址
      let speedBase = 0; //目标点需要减去的基础值，三种运动状态的值都不同
      let intervalTime; //将目标值分为多少步执行，数值越大，步长越小，运动时间越长
      switch (mode) {
        case 'ease-out':
          speedBase = iCurrent;
          intervalTime = duration * 5 / 400;
          break;
        case 'linear':
          speedBase = initState[attr];
          intervalTime = duration * 20 / 400;
          break;
        case 'ease-in':
          let oldspeed = remberSpeed[attr] || 0;
          iSpeed = oldspeed + (target[attr] - initState[attr]) / duration;
          remberSpeed[attr] = iSpeed
          break;
        default:
          speedBase = iCurrent;
          intervalTime = duration * 5 / 400;
      }
      if (mode !== 'ease-in') {
        iSpeed = (target[attr] - speedBase) / intervalTime;
        iSpeed = iSpeed > 0 ? Math.ceil(iSpeed) : Math.floor(iSpeed);
      }
      //判断是否达步长之内的误差距离，如果到达说明到达目标点
      switch (mode) {
        case 'ease-out':
          status = iCurrent != target[attr];
          break;
        case 'linear':
          status = Math.abs(Math.abs(iCurrent) - Math.abs(target[attr])) > Math.abs(iSpeed);
          break;
        case 'ease-in':
          status = Math.abs(Math.abs(iCurrent) - Math.abs(target[attr])) > Math.abs(iSpeed);
          break;
        default:
          status = iCurrent != target[attr];
      }

      if (status) {
        flag = false;
        //opacity 和 scrollTop 需要特殊处理
        if (attr === "opacity") {
          element.style.filter = "alpha(opacity:" + (iCurrent + iSpeed) + ")";
          element.style.opacity = (iCurrent + iSpeed) / 100;
        } else if (attr === 'scrollTop') {
          element.scrollTop = iCurrent + iSpeed;
        } else {
          element.style[attr] = iCurrent + iSpeed + 'px';
        }
      } else {
        flag = true;
      }

      if (flag) {
        clearInterval(element.timer);
        if (callback) {
          callback();
        }
      }
    })
  }, 20);
}

export const typeOf = (val) => {
  return Object.prototype.toString.call(val).match(/^\[object\s(.*)\]$/)[1].toLowerCase();
};

export const arrayEquals = (array1, array2) => {
  if (array1.length != array2.length) return false;

  let sameItemArr = [];
  for (let i = 0; i < array1.length; i++) {
    let isExist = false;
    for (let j = 0; j < array2.length; j++) {
      if (JSON.stringify(array2[j]) == JSON.stringify(array1[i])) {
        isExist = true;
        break;
      }
    }
    if (isExist) sameItemArr.push(array1[i]);
  }

  return sameItemArr.length == array1.length;
};

export const getCourseTypeText = (courseType) => {
  let courseTypeText = "";
  switch (courseType) {
    case 1: {
      courseTypeText = "大学补习";
      break;
    }
    case 2: {
      courseTypeText = "应试英语";
      break;
    }
    case 3: {
      courseTypeText = "职业培训";
      break;
    }
    case 4: {
      courseTypeText = "新生引流";
      break;
    }
  }
  return courseTypeText;
};

export const getAccountTypeByCourseType = (courseType) => {
  let accountType = 0;
  switch (courseType) {
    case 1: {
      accountType = 2;
      break;
    }
    case 2: {
      accountType = 10;
      break;
    }
    case 3: {
      accountType = 9;
      break;
    }
    case 4: {
      accountType = 18;
      break;
    }
  }
  return accountType;
};

export const getCourseTypeList = (isTraining, excludeEnglish) => {
  if (isTraining){
    return [{ Key: 3, Value: "职业培训" }];
  }else{
    let list = [
      { Key: 1, Value: "大学补习" },
      { Key: 2, Value: "应试英语" },
      { Key: 3, Value: "职业培训" },
      { Key: 4, Value: "新生引流" }
    ];
    if (excludeEnglish){
      list.splice(1, 1);
    }
    return list;
  }
};

export const convertToFloat = (value) => {
  let f = 0;
  if (typeof value == "string") {
    f = parseFloat(value);
  } else {
    f = value;
  }
  let str = f.toFixed(2);
  return parseFloat(str);
};

export const getGlobalPriceSettingByType = (gpSettings, type) => {
  let result = null;

  if (!!gpSettings && gpSettings.length > 0) {
    let price = gpSettings.filter(i => i.Type == type);
    if (!!price && price.length > 0) {
      result = price[0];
    }
  }

  return result;
};

export const getUniversityCourseTypeList = () => {
  let list = [
    { Key: 1, Value: "Lecture" },
    { Key: 2, Value: "Lab" },
    { Key: 3, Value: "Tutorial" }];
  return list;
};

//对字符串进行加密
export const compileStr = (code) => {
  var c = String.fromCharCode(code.charCodeAt(0) + code.length);
  for (var i = 1; i < code.length; i++) {
    c += String.fromCharCode(code.charCodeAt(i) + code.charCodeAt(i - 1));
  }
  return escape(c);
}

//字符串进行解密
export const uncompileStr = (code) => {
  code = unescape(code);
  var c = String.fromCharCode(code.charCodeAt(0) - code.length);
  for (var i = 1; i < code.length; i++) {
    c += String.fromCharCode(code.charCodeAt(i) - c.charCodeAt(i - 1));
  }
  return c;
}

export const getTimezoneName = () => {
  let tmSummer = new Date(Date.UTC(2005, 6, 30, 0, 0, 0, 0));
  let so = -1 * tmSummer.getTimezoneOffset();
  let tmWinter = new Date(Date.UTC(2005, 12, 30, 0, 0, 0, 0));
  let wo = -1 * tmWinter.getTimezoneOffset();

  if (-660 == so && -660 == wo) return 'Pacific/Midway';
  if (-600 == so && -600 == wo) return 'Pacific/Tahiti';
  if (-570 == so && -570 == wo) return 'Pacific/Marquesas';
  if (-540 == so && -600 == wo) return 'America/Adak';
  if (-540 == so && -540 == wo) return 'Pacific/Gambier';
  if (-480 == so && -540 == wo) return 'US/Alaska';
  if (-480 == so && -480 == wo) return 'Pacific/Pitcairn';
  if (-420 == so && -480 == wo) return 'US/Pacific';
  if (-420 == so && -420 == wo) return 'US/Arizona';
  if (-360 == so && -420 == wo) return 'US/Mountain';
  if (-360 == so && -360 == wo) return 'America/Guatemala';
  if (-360 == so && -300 == wo) return 'Pacific/Easter';
  if (-300 == so && -360 == wo) return 'US/Central';
  if (-300 == so && -300 == wo) return 'America/Bogota';
  if (-240 == so && -300 == wo) return 'US/Eastern';
  if (-240 == so && -240 == wo) return 'America/Caracas';
  if (-240 == so && -180 == wo) return 'America/Santiago';
  if (-180 == so && -240 == wo) return 'Canada/Atlantic';
  if (-180 == so && -180 == wo) return 'America/Montevideo';
  if (-180 == so && -120 == wo) return 'America/Sao_Paulo';
  if (-150 == so && -210 == wo) return 'America/St_Johns';
  if (-120 == so && -180 == wo) return 'America/Godthab';
  if (-120 == so && -120 == wo) return 'America/Noronha';
  if (-60 == so && -60 == wo) return 'Atlantic/Cape_Verde';
  if (0 == so && -60 == wo) return 'Atlantic/Azores';
  if (0 == so && 0 == wo) return 'Africa/Casablanca';
  if (60 == so && 0 == wo) return 'Europe/London';
  if (60 == so && 60 == wo) return 'Africa/Algiers';
  if (60 == so && 120 == wo) return 'Africa/Windhoek';
  if (120 == so && 60 == wo) return 'Europe/Amsterdam';
  if (120 == so && 120 == wo) return 'Africa/Harare';
  if (180 == so && 120 == wo) return 'Europe/Athens';
  if (180 == so && 180 == wo) return 'Africa/Nairobi';
  if (240 == so && 180 == wo) return 'Europe/Moscow';
  if (240 == so && 240 == wo) return 'Asia/Dubai';
  if (270 == so && 210 == wo) return 'Asia/Tehran';
  if (270 == so && 270 == wo) return 'Asia/Kabul';
  if (300 == so && 240 == wo) return 'Asia/Baku';
  if (300 == so && 300 == wo) return 'Asia/Karachi';
  if (330 == so && 330 == wo) return 'Asia/Calcutta';
  if (345 == so && 345 == wo) return 'Asia/Katmandu';
  if (360 == so && 300 == wo) return 'Asia/Yekaterinburg';
  if (360 == so && 360 == wo) return 'Asia/Colombo';
  if (390 == so && 390 == wo) return 'Asia/Rangoon';
  if (420 == so && 360 == wo) return 'Asia/Almaty';
  if (420 == so && 420 == wo) return 'Asia/Bangkok';
  if (480 == so && 420 == wo) return 'Asia/Krasnoyarsk';
  if (480 == so && 480 == wo) return 'Australia/Perth';
  if (540 == so && 480 == wo) return 'Asia/Irkutsk';
  if (540 == so && 540 == wo) return 'Asia/Tokyo';
  if (570 == so && 570 == wo) return 'Australia/Darwin';
  if (570 == so && 630 == wo) return 'Australia/Adelaide';
  if (600 == so && 540 == wo) return 'Asia/Yakutsk';
  if (600 == so && 600 == wo) return 'Australia/Brisbane';
  if (600 == so && 660 == wo) return 'Australia/Sydney';
  if (630 == so && 660 == wo) return 'Australia/Lord_Howe';
  if (660 == so && 600 == wo) return 'Asia/Vladivostok';
  if (660 == so && 660 == wo) return 'Pacific/Guadalcanal';
  if (690 == so && 690 == wo) return 'Pacific/Norfolk';
  if (720 == so && 660 == wo) return 'Asia/Magadan';
  if (720 == so && 720 == wo) return 'Pacific/Fiji';
  if (720 == so && 780 == wo) return 'Pacific/Auckland';
  if (765 == so && 825 == wo) return 'Pacific/Chatham';
  if (780 == so && 780 == wo) return 'Pacific/Enderbury'
  if (840 == so && 840 == wo) return 'Pacific/Kiritimati';
  return 'US/Pacific';
}

export const toDecimal = (x, length) => {
  var f = parseFloat(x);
  if (isNaN(f)) {
    return 0;
  }
  if (f == 0){
    return 0;
  }
  if (typeof length == "undefined"){
    length = 2;
  }
  let factor = Math.pow(10,length);
  f = Math.round((f * factor).toFixed(2)) / factor;
  return f;
}

export const getScoreColor = (score) => {
  if (score == null || typeof score == "undefined") {
    return "";
  }
  if (score <= 0.75) {
    return "cs-score-poor";
  } else if (score <= 1.25) {
    return "cs-score-fair";
  } else if (score <= 2.25) {
    return "cs-score-good";
  } else {
    return "cs-score-excellent";
  }
}

export const getStudyAbroadUniversityScoreColor = (score) => {
  if (!score && score !== 0) {
    return "";
  }

  if (isNaN(score)){
    score = score.toUpperCase();
    if (score.indexOf("A")>=0){
      return "cs-score-excellent";
    }else if (score.indexOf("B")>=0){
      return "cs-score-good";
    }else if (score.indexOf("C")>=0){
      return "cs-score-fair";
    }else{
      return "cs-score-poor";
    }
  }else{
    if (typeof score == "string"){
      score = parseInt(score);
    }
    if (score < 60) {
      return "cs-score-poor";
    } else if (score < 80) {
      return "cs-score-fair";
    } else if (score <= 90) {
      return "cs-score-good";
    } else {
      return "cs-score-excellent";
    }
  }
}

export const getYearCourseType = () => {
  let list = [
    {
      Value: 1,
      Text: "全年课"
    },
    {
      Value: 2,
      Text: "上学期"
    },
    {
      Value: 3,
      Text: "下学期"
    },
  ];
  return list;
}

export const downloadFile = (result, isReview) => {
  if (isReview){
    setTimeout(() => {
      let href = window.URL.createObjectURL(result.data);
      window.open(href, '_blank');
    });
  }else{
    let fileName = decodeURIComponent(result.filename);
    //downloadFileFromBlob(result.data, fileName);
    setTimeout(() => {
      saveAs(result.data, fileName);
    });
  }
  
  // let blob = result.data;
  // let href = window.URL.createObjectURL(blob);
  // let safari = isSafari();
  // if (isReview) {
  //   window.open(href, '_blank');
  // } else {
  //   try{
  //     let fileName = decodeURIComponent(result.filename);
  //     var link = document.createElement("a");
  //     link.href = href;
  //     link.target = "_blank";
  //     link.download = fileName;

  //     //some browser needs the anchor to be in the doc
  //     document.body.append(link);
  //     window.setTimeout(()=>{
  //       link.click();
  //       link.remove();
  //     }, 500);
      
  //   }catch(e){
  //     window.open(href, '_blank');
  //   }
  // }

  // if (href){
  //   window.setTimeout(()=>{
  //     //释放内存
  //     window.URL.revokeObjectURL(href);
  //   }, 10000);
  // }
}

function downloadFileFromBlob(fileBlob, fileName) {
  if (/\bMSIE\b|\bTrident\b/.test(window.navigator.userAgent)) {
    window.navigator.msSaveOrOpenBlob(fileBlob, fileName);
  } else {
    var fileURL = window.URL.createObjectURL(fileBlob);
    createDownloadElementAndClick(fileURL, fileName);
  }
}

function createDownloadElementAndClick(fileURL, fileName) {
  var anchorElement = window.document.createElement('a');
  anchorElement.href = fileURL;
  //anchorElement.target = '_blank';
  anchorElement.target = '_self';
  anchorElement.download = fileName;
  var event = window.document.createEvent("MouseEvents");
  event.initEvent("click", true, false);
  anchorElement.dispatchEvent(event);
  window.setTimeout(()=>{
    //释放内存
    window.URL.revokeObjectURL(fileURL);
  }, 1000)
}

export const openLink = (href) => {
  let safari = isSafari();
  if (safari) {
    window.open(href, "_blank");
  } else {
    var link = document.createElement("a");
    link.href = href;
    link.target = "_blank";
    link.click();
    window.setTimeout(() => {
      //释放内存
      window.URL.revokeObjectURL(link.href);
    }, 1000);
  }
}

export const isSafari = (userAgent) => {
  if (typeof userAgent == undefined) {
    userAgent = navigator.userAgent;
  }
  return /^((?!chrome|android).)*safari/i.test(userAgent);
}


export const sleep = (time) =>{
  return new Promise((resolve) => setTimeout(resolve, time));
}

export const getTax = (value, taxRate) => {
  let tax = value - value / (1 + taxRate);
  if (tax > 0){
    tax = toDecimal(tax, 4);
  }
  return tax;
}

export const formatPhone = (phone) => {
  if (!phone && phone.length <= 5){
    return phone;
  }
  let length = phone.length;
  let value = phone.substring(length - 5);

  return value.substring(0, 1) + "-" + value.substring(1);
}

export const getMobileOperatingSystem = () => {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

      // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
        return "WindowsPhone";
    }

    if (/android/i.test(userAgent)) {
        return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
    }

    return "Desktop";
}

export const generateVisitorId = async () => {
  let mos = getMobileOperatingSystem();
  let fp = await fingerprintJS.load();
  let result = await fp.get();

  let components = {...result.components};

  //经测试Chrome和Edge生成的VisitorId一样，需加入userAgentData用以区分
  let userAgentData = undefined;
  if (!!navigator.userAgentData) {
    let { brands, mobile, platform } = navigator.userAgentData;
    brands = brands.map((item) => {
      let newItem = {};
      Object.entries(item).filter(entry => entry[0].toLowerCase() !== "version").forEach(entry => {
        newItem[entry[0]] = entry[1];
      });
      return newItem;
    });
    userAgentData = { brands, mobile, platform };
  }
  components.userAgentData = {
    value: userAgentData,
    duration: 0
  };

  //PC的某些信息可能动态改变，计算VisitorId最好排除这些项
  if (mos === "Desktop") {
    delete components.screenResolution;
  }
  
  return fingerprintJS.hashComponents(components);
};

export const convertFileSize = (limit) => {  
  var size = "";  
  if( limit < 0.1 * 1024 ){ //如果小于0.1KB转化成B  
      size = limit.toFixed(2) + "B";    
  }else if(limit < 0.1 * 1024 * 1024 ){//如果小于0.1MB转化成KB  
      size = (limit / 1024).toFixed(2) + "KB";              
  }else if(limit < 0.1 * 1024 * 1024 * 1024){ //如果小于0.1GB转化成MB  
      size = (limit / (1024 * 1024)).toFixed(2) + "MB";  
  }else{ //其他转化成GB  
      size = (limit / (1024 * 1024 * 1024)).toFixed(2) + "GB";  
  }  
    
  var sizestr = size + "";   
  var len = sizestr.indexOf("\.");  
  var dec = sizestr.substr(len + 1, 2);  
  if(dec == "00"){//当小数点后为00时 去掉小数部分  
      return sizestr.substring(0,len) + sizestr.substr(len + 3,2);  
  }  
  return sizestr;  
}

export const getCurrencyMark = (currency) => {
  switch(currency){
    case 1:{
      return "￥";
    }
    case 2:{
      return "$";
    }
  }
  return "";
}

export const getCurrencyPrice = (currency, priceCAD, priceCNY) => {
  let price= 0;
  switch (currency) {
    case 1:
      price = priceCNY;
      break;
    case 2:
      price = priceCAD;
      break;
  }

  return price;
}

export const getWorkflowStatusClass = (status) =>{
  let className = '';
  switch (status){
     case 1:{
         className ="color-workflow-inProgress";
         break;
     }
     case 2:{
      className ="color-workflow-pending";
         break;
     }
     case 3:{
        className ="color-workflow-paid";
         break;
     }
     case 4:{
      className ="color-workflow-reject";
      break;
    }
  }
  return className;
}

export const getPaymentTypeDescription = (paymentTypeId) => {
  let desc = "";
  switch(paymentTypeId){
    case 1:{
      desc = "现金";
      break;
    }
    case 2:{
      desc = "微信";
      break;
    }
    case 3:{
      desc = "支付宝";
      break;
    }
    case 4:{
      desc = "Debit";
      break;
    }
    case 5:{
      desc = "PayPal";
      break;
    }
    case 6:{
      desc = "银联";
      break;
    }
    case 7:{
      desc = "VISA";
      break;
    }
    case 8:{
      desc = "MasterCard";
      break;
    }
    case 9:{
      desc = "EMT";
      break;
    }
    case 10:{
      desc = "支票";
      break;
    }
  }
  return desc;
}

export const getAutonomousWorkflowStatusList = (includeAll) => {
  let list = [];
  if (includeAll){
    list.push({ key: "", value: "所有支付状态" });
  }
  let statusList = [
    { key: 1, value: "待付款" },
    { key: 2, value: "待确认" },
    { key: 3, value: "已支付" },
    { key: 4, value: "未通过" },
  ];
  return list.concat(statusList);
}

function fallbackCopyTextToClipboard(text) {
  var textArea = document.createElement("textarea");
  textArea.value = text;
  
  // Avoid scrolling to bottom
  textArea.style.top = "0";
  textArea.style.left = "0";
  textArea.style.position = "fixed";

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  let isSuccess = true;
  try {
    var successful = document.execCommand('copy');
    var msg = successful ? 'successful' : 'unsuccessful';
    console.log('Fallback: Copying text command was ' + msg);
  } catch (err) {
    console.error('Fallback: Oops, unable to copy', err);
    isSuccess = false;
  }

  document.body.removeChild(textArea);
  return isSuccess;
}
export const copyTextToClipboard = (text) => {
  return new Promise((resolve) => {
    if (!navigator.clipboard) {
      let result = fallbackCopyTextToClipboard(text);  
      resolve(result);
    }

    navigator.clipboard.writeText(text).then(function() {
      resolve(true);
    }, function(err) {
      console.error('Async: Could not copy text: ', err);
      resolve(false);
    });
  });
}

export const getDiscountDesc = (value) => {
  let desc = "";
  if (value){
    value = value * 10;
    if (value> parseInt(value)){
      value = value * 10;
    }
    value = parseInt(value);
    desc = value.toString() + "折";
  }
  return desc;
}

export const redirect = (router, userManager) => {
  if (userManager.isSales || userManager.isAssistant || userManager.isReceptionist 
    || userManager.isEducationalAssistant || userManager.isInternationalSales) {
    router.push("/admin/studentList");
  } else if (userManager.isFinancial) {
    router.push("/finance/accountList");
  } else if (userManager.isTeacher) {
    router.push("/teacher/activateCourse");
  } else if (userManager.isPlatformEditor) {
    router.push("/admin/schoolHotList");
  } else if (userManager.isPersonnelManagement) {
    router.push("/admin/accountManage");
  } else if (userManager.isStudyAbroad) {
    router.push("/studyAbroad/studentInfoList");
  } else {
    router.push("/admin/studentList");
  }
}

/*
 *  检查当前浏览器环境是否是iOS设备（包括Safari和Chrome）
 *  @returns {boolean} 如果是iOS设备返回true，否则返回false
 */
export const isIOSDevice = () => {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
  // 排除Windows Phone
  if (window.MSStream) {
    return false;
  }
  
  // 1. 检测iPhone和iPod（这些通常能检测到）
  if (/iPhone|iPod/.test(userAgent)) {
    return true;
  }
  
  // 2. 检测iOS上的Chrome浏览器（CriOS）
  if (/CriOS/i.test(userAgent)) {
    return true;
  }
  
  // 3. 检测iOS上的Firefox（FxiOS）
  if (/FxiOS/i.test(userAgent)) {
    return true;
  }
  
  // 4. 检测iOS上的Opera（OPiOS）
  if (/OPiOS/i.test(userAgent)) {
    return true;
  }
  
  // 5. 检测旧版本iPad（userAgent中包含iPad）
  if (/iPad/.test(userAgent)) {
    return true;
  }
  
  // 6. 检测新版本iPad（iPadOS 13+）：userAgent显示为Mac但实际是iPad
  // iPadOS 13+的Safari userAgent会显示为Mac，但可以通过以下特征检测：
  // - navigator.platform === 'MacIntel'
  // - 有触摸支持（navigator.maxTouchPoints > 1 或 'ontouchend' in window）
  // - 是Safari浏览器（不是Chrome等其他浏览器）
  var isMacIntel = navigator.platform === 'MacIntel';
  var hasTouchPoints = navigator.maxTouchPoints > 1;
  var hasTouchEvents = 'ontouchend' in window;
  var isSafari = /Safari/.test(userAgent) && !/Chrome|CriOS|FxiOS|OPiOS|Edg/.test(userAgent);
  
  // iPadOS 13+的iPad在Safari中会显示为Mac，但有触摸支持
  if (isMacIntel && (hasTouchPoints || hasTouchEvents) && isSafari) {
    return true;
  }
  
  // 7. 检测iOS Safari的standalone模式（添加到主屏幕后的模式）
  if (window.navigator.standalone === true) {
    return true;
  }
  
  // 8. 使用platform库辅助检测（如果可用）
  try {
    if (platform && platform.os) {
      var osFamily = platform.os.family || '';
      if (/iOS|iPhone OS|iPad/.test(osFamily)) {
        return true;
      }
    }
  } catch (e) {
    // platform库可能不可用，忽略错误
  }
  
  return false;
};


// WEBPACK FOOTER //
// ./src/config/mUtils.js